import { Pipe, PipeTransform } from "@angular/core";
import * as moment from 'moment-timezone';

@Pipe({ 
  name: 'timeZonedDate',
  standalone: false
})
export class TimeZonedDatePipe implements PipeTransform {
  transform(value: string | Date, format: string = 'YYYY.MM.DD. HH:mm', timeZone: string = 'Europe/Budapest'): string {
    if(!value || (value as string).length === 0) {
      return;
    }
    return moment.utc(value)?.tz(timeZone)?.locale('hu').format(format);
  }
}